import { Box } from '@mui/material'
import binariiLogo from '../../../assets/images/poweredByBinarii.svg'
import binariiLogoWhite from '../../../assets/images/binariilabsWhite.svg'

interface IPoweredByBinarii {
  light?: 'dark' | 'white'
}

const PoweredByBinariiLogo: React.FC<IPoweredByBinarii> = ({ light = 'dark' }) => (
  <Box
    sx={{
      display: 'flex',
      padding: '1.6rem',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '5.4rem',
      backgroundColor: 'transparent',
    }}
  >
    <Box
      sx={{
        color: '#71717A',
        fontFamily: 'Geist',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        marginRight: '8px',
      }}
    >
      Powered by
    </Box>

    <img
      src={light === 'dark' ? binariiLogo : binariiLogoWhite}
      style={{ width: '93px', height: '18px' }}
      alt="binarii logo"
    />
  </Box>
)

export default PoweredByBinariiLogo
